import IAudit, { IAuditFormData, IAuditListFilters } from "../interfaces/IAudit";
import moment from "moment";
import IFormType from "../interfaces/IFormType";
import { LocationDescriptorObject } from "history";
import { EnviromentVariables } from "../constants/EnviromentVariables";
import { IFormSchema } from "../interfaces/IFormSchema";
import { IPerson } from "../../sg-hpr/models/IPerson";
import { AuditoinnitRouteId } from "../../routes";
import { getRouteHrefById } from "../../../routing";

export const formatAuditCreatedAt = (createdAt: IAudit["createdAt"]) => {
    if (!createdAt) {
        return null;
    }
    const date = moment(createdAt).format("DD.MM.YYYY");
    // const time = moment(createdAt).format("HH:mm")

    return [date].join(" ");
};



export const resolveStaticFilters = (filters: IAuditListFilters, overwrites: Partial<IAuditListFilters> = {}): IAuditListFilters => ({
    ...filters,
    formType: undefined,
    responsiblePerson: undefined,
    status: undefined,
    freeText: "",
    ...overwrites
})

export const auditToSearchableText = (
    formData: IAuditFormData,
    formSchema: IFormSchema,
    persons: Array<IPerson>
) => {
    let parts: Array<string> = [];
    parts = parts.concat(persons.map((person) => person.fullname).join(" "));

    const toValues = (obj: any): string => {
        if (obj instanceof Object) {
            return Object.values(obj).map(toValues).join(" ")
        }
        const type = typeof obj
        if (type === "boolean") return "";
        if (type === "undefined") return "";
        return String(obj)
    };

    parts = parts.concat(toValues(formData));

    return parts.join(" ")
}


//
// Page href makers
//

export const makeAuditPdfFileHref = (pdfGuid: string): string => {
    let randomId = Math.random().toString(36).substring(6);
    return `${EnviromentVariables.pdfGenerateUrl}/pdf-generate/file/${pdfGuid}/download?cache-key=${randomId}`
};


export const makeAnonPermitHref = (packageId: any, printLanguage: any, pdf: boolean = false): string => {
    const baseUrl = EnviromentVariables.production || !pdf ? window.location.origin : EnviromentVariables.developmentPdfGenerationUrl
    return `${baseUrl}${EnviromentVariables.publicUrl || ""}${getRouteHrefById(AuditoinnitRouteId.AnonymousAudit, { package: packageId })}?lang=${printLanguage}`
};

export const makeFrontPageHref = (): LocationDescriptorObject => {
    return {
        pathname: getRouteHrefById(AuditoinnitRouteId.AuditoinnitFrontPage),
    }
};

export const makeUnauthorizedHref = (): LocationDescriptorObject => {
    return makeFrontPageHref()
};


export const makeNewAuditPageHref = (formType: IFormType["guid"], baseAudit: IAudit["guid"] = "null"): LocationDescriptorObject => {
    return {
        pathname: getRouteHrefById(AuditoinnitRouteId.InitializeAuditPage, { formType, baseAudit }),
    }
};

export const makeEditAuditPageHref = (audit: IAudit["guid"], initialized = false, clearLocalEdits = false): LocationDescriptorObject => {
    return {
        pathname: getRouteHrefById(AuditoinnitRouteId.EditAuditPage, { audit }),
        state: { initialized, clearLocalEdits }
    }
};

export const makeAuditPageHref = (audit: IAudit["guid"]): LocationDescriptorObject => {
    return {
        pathname: getRouteHrefById(AuditoinnitRouteId.AuditPage, { audit }),
        // state: { audit }
    }
};

export const makeAuditsPageHref = (filters?: Partial<IAuditListFilters>): LocationDescriptorObject => {
    return {
        pathname: getRouteHrefById(AuditoinnitRouteId.AuditsPage),
        state: { filters }
    }
};


export const makeMapPageHref = (): LocationDescriptorObject => {
    return {
        pathname: getRouteHrefById(AuditoinnitRouteId.MapPage),
    }
};


